import { createQueryKeys } from '@lukemorales/query-key-factory';

import { get } from '@/api/api';
import type { FanguardApiContractsTicketTicketModel } from 'src/api/generated';

export const TICKETS_URI = 'tickets';

export const ticketsQueries = createQueryKeys(TICKETS_URI, {
  all: null,
  personTickets: (personId: string, eventId: string) => ({
    queryKey: [personId, eventId],
    queryFn: async () => {
      const response = await get<FanguardApiContractsTicketTicketModel[]>({
        uri: `${TICKETS_URI}/${eventId}/person/${personId}`,
      });
      return response.data;
    },
  }),
});
